import { faFileDoc, faFilePdf } from '@fortawesome/pro-solid-svg-icons';
import { downloadSingleMailerUrl } from 'bundles/connect/helpers/prospect_api';
import React from 'react';
import { Button } from 'components/ui/button';
import { Modal } from 'react-bootstrap-5';

type DownloadModalProps = {
  callListId: number;
  templateId: number;
  callListItemId: number;
  show: boolean;
  onHide: () => void;
};

export default function SingleDownloadModal(
  { callListId, templateId, callListItemId, show, onHide }: DownloadModalProps
) {

  const handleDownload = (format: 'docx' | 'pdf') => {
    const url = downloadSingleMailerUrl(callListId, templateId, callListItemId, format);

    window.open(url, '_blank');
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header className="flex-row" closeButton>
        <Modal.Title>Download Mailer</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-2">
        <div>
          Please select your download format from the options below.
        </div>
        <div className="d-flex gap-2">
          <Button
            className="flex-grow-1"
            icon={faFileDoc}
            label="Download as Docx"
            variant="outline"
            onClick={() => handleDownload('docx')}
          />
          <Button
            className="flex-grow-1"
            icon={faFilePdf}
            label="Download as PDF"
            variant="outline"
            onClick={() => handleDownload('pdf')}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onHide} />
      </Modal.Footer>
    </Modal>
  );
}
